import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../../components/Button/Button'
import { useButtonClassName } from '../../../components/Button/useButtonClassName'
import { McpLogoRow } from '../../../components/McpLogoRow/McpLogoRow'
import { OnboardingBannerLayout } from '../EmptyStates/Components/OnboardingBannerLayout'
import { ReactComponent as Sparkling } from '../../../assets/images/sparkling.svg'
import { type McpPromoBlockConfig } from './mcpPromoConfig'

interface McpPromoBannerProps {
  block: McpPromoBlockConfig
  onCtaClick: () => void
  onDismiss: () => void
}

export const McpPromoBanner: FC<McpPromoBannerProps> = ({ block, onCtaClick, onDismiss }) => {
  const navigate = useNavigate()
  const externalCtaClassName = useButtonClassName('grayButton', 'text-decoration-none')

  const { cta } = block

  const handleRouteClick = () => {
    onCtaClick()
    if (cta.kind === 'route') {
      navigate(cta.to)
    }
  }

  return (
    <OnboardingBannerLayout title={block.title} subtitle={block.subtitle} footer={<McpLogoRow />} onDismiss={onDismiss}>
      {cta.kind === 'external' ? (
        <a href={cta.href} target='_blank' rel='noopener noreferrer' className={externalCtaClassName} aria-label={cta.label} onClick={onCtaClick}>
          <Sparkling className='flex-shrink-0' />
          <span className='fw-bold small text-truncate mw-100'>{cta.label}</span>
        </a>
      ) : (
        <Button variant='grayButton' aria-label={cta.label} onClick={handleRouteClick}>
          <Sparkling className='flex-shrink-0' />
          <span className='fw-bold small text-truncate mw-100'>{cta.label}</span>
        </Button>
      )}
    </OnboardingBannerLayout>
  )
}
